export default "__VITE_ASSET__8a1d450d__"